import { render } from "./CalendarComponent.vue?vue&type=template&id=045f13d5&ts=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__